import React, {Component} from "react";
import './index.css';
import PropTypes from 'prop-types';
import MyComponent from '../../../Components/MyComponent';

class PageUpdateHistory extends MyComponent {
    constructor (props) {
        super(props);

        // BUG, FEATURE, OPTIMIZE, DEPRECATE
        // HIGH, MEDIUM, LOW

        this.state = {
            changeList: []
        };
    }

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.state.changeList !== nextState.changeList;
    }

    componentDidMount () {
        fetch('/change-list.json')
            .then(response => response.json())
            .then(data => {
                this.setState({changeList: data});
            })
            .catch(message => {
                console.log(message);
            });
    }

    render () {
        const {state} = this;

        return <div className={'PageUpdateHistory'}>
            {state.changeList.map((item, index) => <Update key={index} version={item.version} date={item.date} changes={item.changes || []}/>)}
        </div>;
    }
}

class Update extends Component {
    constructor (props) {
        super(props);

        this.state = {};
    }

    static defaultProps = {
        version: null,
        date: null,
        changes: []
    };

    static propTypes = {
        version: PropTypes.string,
        date: PropTypes.string,
        changes: PropTypes.array
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return false;
    }

    render () {
        const {version, date, changes} = this.props;
        const types = {BUG: 'باگ', FEATURE: 'ویژگی', DEPRECATE: 'منسوخ', OPTIMIZE: 'بهینه‌سازی'};
        const priorities = {HIGH: 'بالا', MEDIUM: 'متوسط', LOW: 'پایین'};

        return <div className={'Update'}>
            {/*<div className={'dis-f'}>*/}
            {/*    <label className="label">ورژن برنامه: {version || '-'}</label>*/}
            {/*    <label className="label">تاریخ: {date || '-'}</label>*/}
            {/*</div>*/}
            {changes.length ? <table>
                <tbody>
                <tr>
                    <td colSpan={2}>ورژن برنامه: {version || '-'}</td>
                    <td colSpan={2}>تاریخ: {date || '-'}</td>
                </tr>
                <tr>
                    <th>نوع</th>
                    <th colSpan={2}>توضیحات</th>
                    <th>ضرورت</th>
                </tr>
                {changes.map((item, index) => <tr key={index}>
                    <td className={`center label ${item.type || 'EMPTY'}`}>{types[item.type] || '-'}</td>
                    <td colSpan={2}>{item.description}</td>
                    <td className={`center label ${item.priority || 'EMPTY'}`}>{priorities[item.priority] || '-'}</td>
                </tr>)}
                </tbody>
            </table> : null}
        </div>;
    }
}

export default PageUpdateHistory;